const state = {
  isLoading: false,
  showBackdrop: false,
  showModal: false,
};

const mutations = {
  setIsLoading: (state, payload) => state.isLoading = payload,
  toggleBackdrop: (state, payload) => state.showBackdrop = payload,
  toggleModal: (state, payload) => state.showModal = payload,
};

const actions = {
  setIsLoading({ commit }, payload) {
    commit("setIsLoading", payload);
  },
  toggleBackdrop({ commit }, payload) {
    commit("toggleBackdrop", payload);
  },
  toggleModal({ commit }, payload) {
    commit("toggleBackdrop", payload);
    commit("toggleModal", payload);
  },
};

const getters = {
  isLoading: (state) => state.isLoading,
  showBackdrop: (state) => state.showBackdrop,
  showModal: (state) => state.showModal,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
